import { SAMPLE_BATCH_DOCUMENT, SAMPLE_DOCUMENT } from "@/constants";
import { JsonDocumentEditor } from "./JsonDocumentEditor";
import { usePipelineStaging } from "./pipelineStaging";
import {
  SourceDeliversDropdown,
  useSourceDelivers,
} from "./SourceDeliversDropdown";

// Figma Bridge_PipelineCode (13970-93956) — the Studio input document editor:
// the shared JSON editor panel with the sample-document loaders (same
// constants as old /studio) on the empty state and in the context menu.
export function InputDocumentEditor() {
  const { inputDocument, setInputDocument, sources, unstage } =
    usePipelineStaging();
  // The "Source delivers" footer control (TTTL-268). Passed only while it
  // has something to show: the status bar draws a divider in front of any
  // extras it is given, which must not dangle before an empty control.
  const delivers = useSourceDelivers();
  // Emptying the document down to the placeholder — by typing, cutting,
  // the Clean button or ⌘Z past the sample fill — takes the staged source
  // with it, like the row's remove button (TTTL-191 did it for ⌘Z only;
  // TTTL-254 for every way).
  const source = sources[0];
  return (
    <JsonDocumentEditor
      testIdBase="input-document"
      documentName="input document"
      value={inputDocument}
      onChange={setInputDocument}
      onEmptied={source ? () => unstage(source.id) : undefined}
      placeholder="Paste a JSON here, or choose an option below"
      statusExtras={
        delivers ? <SourceDeliversDropdown {...delivers} /> : undefined
      }
      samples={[
        {
          id: "sample-document",
          label: "Sample document",
          content: SAMPLE_DOCUMENT,
        },
        {
          id: "batch-documents",
          label: "Batch documents (3)",
          content: SAMPLE_BATCH_DOCUMENT,
        },
      ]}
    />
  );
}
